/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AgentGamingListOperation = "ADD" | "REMOVE" | "%future added value";
export type ModifyAgentGamingAgentWatchlistMutationVariables = {
    agentId: string;
    operation: AgentGamingListOperation;
    comment?: string | null | undefined;
};
export type ModifyAgentGamingAgentWatchlistMutationResponse = {
    readonly modifyAgentGamingAgentWatchlist: {
        readonly success: boolean;
    } | null;
};
export type ModifyAgentGamingAgentWatchlistMutation = {
    readonly response: ModifyAgentGamingAgentWatchlistMutationResponse;
    readonly variables: ModifyAgentGamingAgentWatchlistMutationVariables;
};



/*
mutation ModifyAgentGamingAgentWatchlistMutation(
  $agentId: ID!
  $operation: AgentGamingListOperation!
  $comment: String
) {
  modifyAgentGamingAgentWatchlist(agentId: $agentId, operation: $operation, comment: $comment) {
    success
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "comment"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operation"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "agentId",
        "variableName": "agentId"
      },
      {
        "kind": "Variable",
        "name": "comment",
        "variableName": "comment"
      },
      {
        "kind": "Variable",
        "name": "operation",
        "variableName": "operation"
      }
    ],
    "concreteType": "ModifyAgentGamingAgentWatchlist",
    "kind": "LinkedField",
    "name": "modifyAgentGamingAgentWatchlist",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModifyAgentGamingAgentWatchlistMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ModifyAgentGamingAgentWatchlistMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d3fef2ac0d01821e9cfaf1a210e010a2",
    "id": null,
    "metadata": {},
    "name": "ModifyAgentGamingAgentWatchlistMutation",
    "operationKind": "mutation",
    "text": "mutation ModifyAgentGamingAgentWatchlistMutation(\n  $agentId: ID!\n  $operation: AgentGamingListOperation!\n  $comment: String\n) {\n  modifyAgentGamingAgentWatchlist(agentId: $agentId, operation: $operation, comment: $comment) {\n    success\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f95b5e959e0fcd5b93a0dc7a05b60c40';
export default node;
